import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectGoogleAuthConfirmResponseMessage } from '@shared/utils/DirectMessages/DirectGoogleAuthConfirmResponseMessage';
export class GoogleAuthConfirmResponseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectGoogleAuthConfirmResponseMessage();
        message.Success = fieldSet.GetValue(FieldsFactory.FIELD_SUCCESS);
        return [message];
    }
}
